/* unplugin-vue-components disabled */import { render } from "./wechat-login.vue?vue&type=template&id=61bf3867"
import script from "./wechat-login.vue?vue&type=script&lang=js"
export * from "./wechat-login.vue?vue&type=script&lang=js"

import "./wechat-login.vue?vue&type=style&index=0&id=61bf3867&lang=less"

import exportComponent from "E:\\ProjectsWorkspaces\\WebStormProjects\\OCHS-Product-Disda-Online-Car-Hailing-H5\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_7401bc125e2957ce4091f6809056b31d\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__